export const productTypeOptions = [
	{ value: 'MAIN_DISH', label: 'product.form.main.type_options.product' },
	{ value: 'TOPPING', label: 'product.form.main.type_options.addition' },
	{ value: 'BEVERAGE', label: 'product.form.main.type_options.drink' },
	{ value: 'BOTTLE_DEPOSIT', label: 'product.form.main.type_options.deposit' },
	{ value: 'MENU', label: 'product.form.main.type_options.menu' },
	{ value: 'TOBACCO', label: 'product.form.main.type_options.tobacco' },
	{ value: 'BASIC_FOOD', label: 'product.form.main.type_options.basicFood' },
]
